import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { Typography } from "@mui/material";
import moment from "moment";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  GetYojnaWithrawRequestDashboard,
  UpdateWithdrawRequestFromDepositToWithdraw,
} from "../../Helpers/APIEndPoints/EndPoints";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useNavigate } from "react-router-dom";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import "./Sanjeevani.css";
type DashData = {
  [index: number]: any;
};

type SelectedItems = {
  [key: number]: number;
};

const WithdrawStatmentGrid = (props) => {
  const { activeTab } = props;
  let navigate = useNavigate();
  const context = getContext();
  const [pageSize] = useState(10);
  let MemberId1 = context.MemberId;
  const [start, setStart] = useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  // const [selectedId, setSelectedId] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalSchemes, setTotalSchemes] = useState(0);
  const [dashboardData, setDashboardData] = useState([]);
  const [sortDirection, setSortDirection] = useState("");
  const [selectedItems, setSelectedItems] = useState<SelectedItems>({});
  const [currentFilters, setCurrentFilters] = useState(null);
  const [showGrids, setShowGrids] = useState(false);

  const [totalMatureAmount, setTotalMatureAmount] = useState(0);
  const [dashboardData2, setDashboardData2] = useState([]);
  const [dataCount2, setDataCount2] = useState(0);

  const [totalUnMaturedAmount, setTotalUnMaturedAmount] = useState(0);
  const [dashboardData3, setDashboardData3] = useState([]);
  const [dataCount3, setDataCount3] = useState(0);

  const [checkedItems2, setCheckedItems2] = useState([]);
  const [checkedItems3, setCheckedItems3] = useState([]);
  const [checkedItems4, setCheckedItems4] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const CreatedBy =  context.Id,

  useEffect(() => {
    if (activeTab !== null) {
      getDashboardData();
    }
  }, [activeTab, start, sortColumn, sortDirection, currentFilters]);

  // useEffect(() => {
  //   if (showGrids) {
  //     getDashboardData2();
  //     getDashboardData3();
  //   }
  // }, [showGrids]);

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  // create second check to display same selected record
  // const handleCheckboxChange = (e, dashdata: DashData) => {
  //   const selectedId: number = dashdata[2];
  //   const finalAmount: number = dashdata[7];
  //   const maturityStatus: string = dashdata[8];
  //   const Amount: Number = dashdata[5];
  //   const RateOfIntrest: number = dashdata[9];
  //   const DepositNumber: number = dashdata[10];
  //   const isChecked: boolean = e.currentTarget.checked;

  //   // Update CheckedItems
  //   const newItem = {
  //     RequestId: selectedId,
  //     AmountWithROI: finalAmount,
  //     Amount: Amount,
  //     ROI: RateOfIntrest,
  //     DepositNumber: DepositNumber,
  //     CreatedBy: context.Id,
  //   };
  //   setCheckedItems((prevItems) =>
  //     isChecked
  //       ? [...prevItems, newItem]
  //       : prevItems.filter((item) => item.RequestId !== selectedId)
  //   );

  //   // Update SelectedItems
  //   setSelectedItems((prevItems: SelectedItems) => {
  //     if (isChecked) {
  //       return {
  //         ...prevItems,
  //         [selectedId]: selectedId,
  //       };
  //     } else {
  //       const { [selectedId]: removedItem, ...rest } = prevItems;
  //       return rest;
  //     }
  //   });

  //   // Update TotalSchemes
  //   setTotalSchemes((prevTotalSchemes: number) =>
  //     isChecked ? prevTotalSchemes + 1 : prevTotalSchemes - 1
  //   );

  //   // Update FinalAmount
  //   setTotalAmount((prevTotalAmount: number) =>
  //     isChecked ? prevTotalAmount + finalAmount : prevTotalAmount - finalAmount
  //   );

  //   // Update DashboardData2 and DashboardData3 if "Select All" was used previously
  //   if (isChecked && maturityStatus === "Matured") {
  //     setDashboardData2((prevData) => [
  //       ...prevData,
  //       {
  //         DocumentNumber: dashdata[3],
  //         selectedId: dashdata[2],
  //         Amount: dashdata[5],
  //         FinalAmount: dashdata[7],
  //         RateOfIntrest: dashdata[9],
  //       },
  //     ]);
  //   } else if (!isChecked && maturityStatus === "Matured") {
  //     setDashboardData2((prevData) =>
  //       prevData.filter((item) => item.selectedId !== selectedId)
  //     );
  //   }

  //   if (
  //     (isChecked && maturityStatus === "NearMatureDate") ||
  //     (isChecked && maturityStatus === "NotMatured")
  //   ) {
  //     setDashboardData3((prevData) => [
  //       ...prevData,
  //       {
  //         DocumentNumber: dashdata[3],
  //         selectedId: dashdata[2],
  //         Amount: dashdata[5],
  //         FinalAmount: dashdata[7],
  //         RateOfIntrest: dashdata[9],
  //       },
  //     ]);
  //   } else if (
  //     (!isChecked && maturityStatus === "NearMatureDate") ||
  //     maturityStatus === "NotMatured"
  //   ) {
  //     setDashboardData3((prevData) =>
  //       prevData.filter((item) => item.selectedId !== selectedId)
  //     );
  //   }
  // };

  useEffect(() => {
   
  }, [checkedItems4]);

  const handleCheckboxChange = (e, dashdata: DashData) => {
    
    const selectedId: number = dashdata[2];
    const finalAmount: number = dashdata[7];
    const maturityStatus: string = dashdata[8];
    const Amount: Number = dashdata[5];
    const RateOfIntrest: number = dashdata[9];
    const DepositNumber: number = dashdata[10];
    const isChecked: boolean = e.currentTarget.checked;
    // Add limit only 15 record will be selected
    if (isChecked && checkedItems4.length >= 15) {
      notify(1, "You can select only up to 15 items.");
      return;
    }

    // Update SelectedItems
    setSelectedItems((prevItems: SelectedItems) => {
      if (isChecked) {
        return {
          ...prevItems,
          [selectedId]: selectedId,
        };
      } else {
        const { [selectedId]: removedItem, ...rest } = prevItems;
        return rest;
      }
    });

    // Update TotalSchemes
    setTotalSchemes((prevTotalSchemes: number) =>
      isChecked ? prevTotalSchemes + 1 : prevTotalSchemes - 1
    );

    // Update FinalAmount
    setTotalAmount((prevTotalAmount: number) =>
      isChecked ? prevTotalAmount + finalAmount : prevTotalAmount - finalAmount
    );

    // Update DashboardData2 and DashboardData3 if "Select All" was used previously
    setDashboardData2((prevData) => {
      if (isChecked && maturityStatus === "Matured") {
        const updatedData = [
          ...prevData,
          {
            DocumentNumber: dashdata[3],
            Id: dashdata[2],
            RequestId: dashdata[2],
            AmountWithROI: dashdata[7],
            FinalAmount: dashdata[7],
            Amount: dashdata[5],
            ROI: dashdata[9],
            RateOfIntrest: dashdata[9],
            DepositNumber: dashdata[10],
            CreatedBy: context.Id,
            MemberId: MemberId1,
          },
        ];

        const totalMaturedAmount = updatedData.reduce(
          (sum, item) => sum + item.FinalAmount,
          0
        );
        // item.finalAmount || add in totalMaturedAmount when select All in applied
        setTotalMatureAmount(totalMaturedAmount);
        setDataCount2(prevData.length + 1);
        setCheckedItems2(updatedData); // Set checked items for DashboardData2
        // setCheckedItems4(updatedData);
        return updatedData;
      } else if (!isChecked && maturityStatus === "Matured") {
        const updatedData = prevData.filter((item) => item.Id !== selectedId);
        const totalMatureAmount = updatedData.reduce(
          (sum, item) => sum + item.FinalAmount,
          0
        );
        // item.finalAmount || add in totalMaturedAmount when select All in applied
        setTotalMatureAmount(totalMatureAmount);
        setDataCount2(updatedData.length);
        setCheckedItems2(updatedData); // Set checked items for DashboardData2
        // setCheckedItems4(updatedData);
        // setCheckedItems4([...dashboardData, updatedData]);
        return updatedData;
      }
      return prevData;
    });

    setDashboardData3((prevData) => {
      if (
        (isChecked && maturityStatus === "NearMatureDate") ||
        (isChecked && maturityStatus === "NotMatured")
      ) {
        const updatedData = [
          ...prevData,
          {
            DocumentNumber: dashdata[3],
            Id: dashdata[2],
            RequestId: dashdata[2],
            AmountWithROI: dashdata[7],
            FinalAmount: dashdata[7],
            Amount: dashdata[5],
            ROI: dashdata[9],
            RateOfIntrest: dashdata[9],
            DepositNumber: dashdata[10],
            CreatedBy: context.Id,
            MemberId: MemberId1,
          },
        ];

        const totalUnMaturedAmount = updatedData.reduce(
          (sum, item) => sum + item.FinalAmount,
          0
        );
        // item.finalAmount ||   add in totalUnMaturedAmount when select All in applied
        setTotalUnMaturedAmount(totalUnMaturedAmount);
        setDataCount3(prevData.length + 1);
        setCheckedItems3(updatedData); // Set checked items for DashboardData3
        // setCheckedItems4(updatedData);
        return updatedData;
      } else if (
        (!isChecked && maturityStatus === "NearMatureDate") ||
        maturityStatus === "NotMatured"
      ) {
        const updatedData = prevData.filter((item) => item.Id !== selectedId);
        const totalUnMaturedAmount = updatedData.reduce(
          (sum, item) => sum + item.FinalAmount,
          0
        );
        // item.finalAmount ||   add in totalUnMaturedAmount when select All in applied
        setTotalUnMaturedAmount(totalUnMaturedAmount);
        setDataCount3(updatedData.length);
        setCheckedItems3(updatedData); // Set checked items for DashboardData3
        // setCheckedItems4(updatedData);
        return updatedData;
      }
      return prevData;
    });

    setCheckedItems4((prevCheckedItems) => {
      if (isChecked) {
        return [
          ...prevCheckedItems,
          {
            RequestId: selectedId,
            AmountWithROI: finalAmount,
            Amount: Amount,
            ROI: RateOfIntrest,
            DepositNumber: DepositNumber,
            CreatedBy: context.Id,
            MemberId: MemberId1,
          },
        ];
      } else {
        return prevCheckedItems.filter((item) => item.RequestId !== selectedId);
      }
    });
  };

  //All records are selected
  const handleSelectAll = (e) => {
    const isAllChecked = e.currentTarget.checked;
    const allUpdatedData = dashboardData?.map((item) => ({
      ...item,
      ["Select All"]: isAllChecked,
    }));

    setDashboardData(allUpdatedData);

    // Update TotalSchemes based on checkbox state
    setTotalSchemes(isAllChecked ? allUpdatedData.length : 0);

    // Update TotalAmount based on checkbox state
    const totalAmount = isAllChecked
      ? allUpdatedData.reduce((total, data) => total + data.FinalAmount, 0)
      : 0;
    setTotalAmount(totalAmount);

    // Update TotalMatureAmount based on checkbox state
    const totalMatureAmount = isAllChecked
      ? allUpdatedData
          .filter((data) => data.MaturityStatus === "Matured")
          .reduce((total, data) => total + data.FinalAmount, 0)
      : 0;
    setTotalMatureAmount(totalMatureAmount);

    // Update TotalUnMaturedAmount based on checkbox state
    const totalUnMaturedAmount = isAllChecked
      ? allUpdatedData
          .filter(
            (data) =>
              data.MaturityStatus === "NearMatureDate" ||
              data.MaturityStatus === "NotMatured"
          )
          .reduce((total, data) => total + data.FinalAmount, 0)
      : 0;
    setTotalUnMaturedAmount(totalUnMaturedAmount);

    // Update SelectedItems based on checkbox state
    const selectedItems = isAllChecked
      ? allUpdatedData.reduce((items, data) => {
          items[data.Id] = data.FinalAmount;
          return items;
        }, {})
      : {};
    setSelectedItems(selectedItems);

    // Update CheckedItems based on checkbox state
    const updatedCheckedItems = isAllChecked
      ? allUpdatedData.map((item) => ({
          RequestId: item.RequestId,
          AmountWithROI: item.FinalAmount,
          Amount: item.Amount,
          ROI: item.RateOfIntrest,
          DepositNumber: item.DepositNumber,
          CreatedBy: context.Id,
          MemberId: MemberId1,
        }))
      : [];
    setCheckedItems4(updatedCheckedItems);

    // Update DashboardData2 based on checkbox state
    const maturedData = allUpdatedData.filter(
      (data) => data.MaturityStatus === "Matured"
    );
    //setDashboardData2(isAllChecked ? [...dashboardData2, ...maturedData] : []);
    setDashboardData2(isAllChecked ? maturedData : []);
    setDataCount2(maturedData.length);

    // Update DashboardData3 based on checkbox state
    const unMaturedData = allUpdatedData.filter(
      (data) =>
        data.MaturityStatus === "NearMatureDate" ||
        data.MaturityStatus === "NotMatured"
    );
    setDashboardData3(isAllChecked ? unMaturedData : []);
    setDataCount3(unMaturedData.length);

    if (!isAllChecked) {
      setDashboardData2([]);
      setDashboardData3([]);

      setSelectedItems([]);

      setCheckedItems2([]);
      setCheckedItems3([]);
      setCheckedItems4([]);

      setTotalMatureAmount(0);
      setTotalUnMaturedAmount(0);

      setDataCount2(0);
      setDataCount3(0);
    }
  };

  // Api here to get dashboard data
  const getDashboardData = async () => {
    showLoader();
    try {
      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        YojnaType: "SanjivaniYojna",
        MemberId: MemberId1,
      };

      const resp = await APICall(GetYojnaWithrawRequestDashboard, obj);

      if (resp?.Data?.SNJY_WithdrawRequestList?.length > 0) {
        setDashboardData(resp?.Data?.SNJY_WithdrawRequestList);
        const dataCount = resp?.Data?.SNJY_WithdrawRequestList[0]?.TotalCount;
        setDataCount(dataCount);

        // selectNextTab();
        hideLoader();
      } else {
        setDashboardData([]);
        hideLoader();
      }
    } catch (err) {
      // notify(
      //   ToastType.Error,
      //   "It seems there server is down right now, Please try again later."
      // );
    
    } finally {
      hideLoader();
    }
  };

  //Columns
  const GridColumns = [
    //0
    {
      name: "Select All",
      label: (
        <>
          <span className="endStyle">
            {/* <input
              className="ml-2"
              style={{ verticalAlign: "middle" }}
              key="selectAllCheckbox"
              type="checkbox"
              onChange={
                (e) => handleSelectAll(e)}
              checked={
                dashboardData.length > 0 &&
                Object.keys(selectedItems).length === dashboardData.length
              }
            /> */}
          </span>
        </>
      ),
      options: {
        display: true,
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <input
            type="checkbox"
            checked={!!selectedItems[tableMeta.rowData[2]]}
            key={`checkbox_${tableMeta.rowIndex}`}
            onChange={(e) => {
              handleCheckboxChange(e, tableMeta.rowData);
            }}
          />
        ),
      },
    },
    //1
    {
      name: "MemberId",
      label: "MemberId",
      options: {
        display: false,
      },
    },
    //2
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    //3
    {
      name: "DocumentNumber",
      label: "Document Number",
      options: CommonCellOptions(),
    },
    //4
    {
      name: "ApplicationDate",
      label: "Application Date",
      options: {
        ...CommonCellOptions(true),
        display: true,
      },
    },
    //5
    {
      name: "Amount",
      label: "Amount",
      options: CommonCellOptions(),
    },
    //6
    {
      name: "MaturityDate",
      label: "Maturity Date",
      options: {
        ...CommonCellOptions(true),
        display: true,
        customBodyRender: (value, tableMeta) => {
          const maturityStatus = tableMeta.rowData[8]; // Assuming MaturityStatus index is 8
          let textColor = "black"; // Default text color
          let fontWeight = "normal";

          if (maturityStatus === "Matured") {
            textColor = "green";
            fontWeight = "bold";
          } else if (maturityStatus === "NearMatureDate") {
            textColor = "orange";
            fontWeight = "bold";
          } else if (maturityStatus == "NotMatured") {
            textColor = "black";
          }

          return (
            <Typography
              style={{ color: textColor, fontWeight }}
              fontFamily={"Georama-Regular"}
              fontSize={"14px"}
              component={"span"}
              noWrap={true}
            >
              {moment(value).format(DATE_DISPLAY_FORMAT)}
            </Typography>
          );
        },
      },
    },
    //7
    {
      name: "FinalAmount",
      label: "Final Amount",
      options: CommonCellOptions(),
    },
    //8
    {
      name: "MaturityStatus",
      label: "MaturityStatus",
      options: {
        display: false,
      },
    },
    //9
    {
      name: "RateOfIntrest",
      label: "RateOfIntrest",
      options: {
        display: false,
      },
    },
    //10
    {
      name: "DepositNumber",
      label: "DepositNumber",
      options: {
        display: false,
      },
    },
  ];

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const handleWithdrawButtonClick = (e) => {
    // const isAtLeastOneCheckboxChecked: boolean = e.currentTarget.checked;
    if (totalAmount > 0) {
      setShowGrids(true);
    } else {
      notify(1, "Please select at least one checkbox");
    }
    // setShowGrids(true);
  };

  // Reset selected items
  const handleBackButtonClick = () => {
    setTotalAmount(0);
    setTotalSchemes(0);
    setSelectedItems({});
    setShowGrids(false);
    setTotalMatureAmount(0);
    setTotalUnMaturedAmount(0);
    setDashboardData2([]);
    setDashboardData3([]);

    setDataCount2(0);
    setDataCount3(0);

    setCheckedItems2([]);
    setCheckedItems3([]);
    setCheckedItems4([]);
    // setGridColumns2([]);
    // setGridColumns3([]);
  };

  // const combineData = [...checkedItems2, ...checkedItems3, ...checkedItems4];

  // Post the withdraw list
  const handleProceedClick = async () => {
    showLoader();
    try {
      let combinedData = [];

      if (checkedItems4.length === 0) {
        combinedData = [...checkedItems2, ...checkedItems3];
      } else {
        combinedData = [...checkedItems4];
      }

      const obj = {
        SNJY_WithdrawRequestList: combinedData,
        YojnaType: "SanjivaniYojna",
      };

      const resp = await APICall(
        UpdateWithdrawRequestFromDepositToWithdraw,
        obj
      );

      if (resp.Status === ApiStatus.OK) {
        notify(
          ToastType.Success,
          "Your request has been sent successfully. It would take 2-3 days to approve your transaction."
        );

        getDashboardData();
        setShowGrids(true);
        setTotalAmount(0);
        setTotalSchemes(0);
        setSelectedItems({});
        setShowGrids(false);

        setTotalMatureAmount(0);
        setTotalUnMaturedAmount(0);

        setDashboardData2([]);
        setDashboardData3([]);

        setCheckedItems2([]);
        setCheckedItems3([]);
        setCheckedItems4([]);

        setTotalMatureAmount(0);
        setTotalUnMaturedAmount(0);
      } else if (resp.Status === ApiStatus.Error) {
        notify(ToastType.Error, `${resp.Message}`);
      }
    } catch {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  // Second dashboard start
  const [GridColumns2, setGridColumns2] = useState([
    {
      name: "DocumentNumber",
      label: "Document Number",
      options: { ...CommonCellOptions(), display: true },
    },
    {
      name: "Amount",
      label: "Amount",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "RateOfIntrest",
      label: "ROI",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "FinalAmount",
      label: "Amount With ROI (INR)",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
  ]);

  const Options2 = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount2,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  // thired grid start
  const [GridColumns3, setGridColumns3] = useState([
    {
      name: "DocumentNumber",
      label: "Document Number",
      options: { ...CommonCellOptions(), display: true },
    },
    {
      name: "Amount",
      label: "Amount",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "RateOfIntrest",
      label: "ROI",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "FinalAmount",
      label: "Amount With ROI (INR)",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
  ]);

  const Options3 = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount3,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  return (
    <>
      {!showGrids && (
        <>
          <div className="d-flex widt_total">
            <p className="mb-3">
              Total no of schemes selected : {totalSchemes}
            </p>
            <div className="d-flex totl">
              <p className="main_totl mr-3">
                <span style={{ marginTop: "5px", marginRight: "5px" }}>
                  {" "}
                  Total Amount :{" "}
                </span>
                {/* <div className="totl_amt">{totalAmount.toFixed(2)}</div> */}
                <div className="totl_amt">
                  {totalAmount >= 0 ? totalAmount.toFixed(2) : "0.00"}
                </div>
                <ButtonComponent
                  icon={""}
                  value={"Withdraw"}
                  id={"saveBtn"}
                  // disabled={isDisabled}
                  onClick={handleWithdrawButtonClick}
                />
              </p>
            </div>
          </div>
          <div className="mb-3 pt-3">
            <DynamicGrid
              options={Options}
              data={dashboardData}
              columns={GridColumns}
            />
          </div>
        </>
      )}
      {showGrids && (
        <div className="mb-3 pt-3">
          <>
            <div className="mb-3 pt-3">
              <p className="schemesM_head ">Matured Schems</p>
              <DynamicGrid
                options={Options2}
                data={dashboardData2}
                columns={GridColumns2}
              />
              <p className="totl_mAmt mt-3">
                Total Matured Amount {totalMatureAmount.toFixed(2)}
              </p>
            </div>
            <div className="mb-3 pt-3">
              <p className="schemesUnM_head">Un-Matured Schems</p>
              <DynamicGrid
                data={dashboardData3}
                columns={GridColumns3}
                options={Options3}
              />
              <p className="totl_mAmt mt-3">
                Total Un-Matured Amount {totalUnMaturedAmount.toFixed(2)}
              </p>
            </div>
            <p
              style={{
                backgroundColor: "#db233a",
                padding: "10px",
                color: "white",
                textAlign: "center",
                fontSize: "20px",
                marginBottom: "20px",
              }}
            >
              Total withdrawal Amount{" "}
              {(totalUnMaturedAmount + totalMatureAmount).toFixed(2)}
            </p>
            <div className="proc_btn">
              <ButtonComponent
                icon={"far fa-hand-point-right"}
                value={"Proceed"}
                style={{
                  marginLeft: "0px",
                  backgroundColor: "#7AC143 !important",
                }}
                // id={"saveBtn"}
                disabled={false}
                onClick={handleProceedClick}
                className={"proceed"}
              />
              <ButtonComponent
                icon={"far fa-hand-point-left"}
                value={"Back"}
                style={{
                  marginLeft: "10px",
                  backgroundColor: "#3c5464 !important",
                }}
                // id={"saveBtn"}
                disabled={false}
                onClick={handleBackButtonClick}
                className={"proceed_bkp"}
              />
            </div>
          </>
        </div>
      )}
    </>
  );
};

export default WithdrawStatmentGrid;
